import { Route, Routes } from "react-router-dom";
import Layout from "./components/Layout";
import AboutPage from "./pages/AboutPage";
import BooksPage from "./pages/BooksPage";
import CertificatePage from "./pages/CertificatePage";
import CertificatesListPage from "./pages/CertificatesListPage";
import ContactPage from "./pages/ContactPage";
import ExperiencePage from "./pages/ExperiencePage";
import HeroPage from "./pages/HeroPage";
import NotFoundPage from "./pages/NotFoundPage";
import ProjectsPage from "./pages/ProjectsPage";
import ResearchPage from "./pages/ResearchPage";
import ResumePage from "./pages/ResumePage";
import SkillsPage from "./pages/SkillsPage";

function App() {
  return (
    <Routes>
      <Route element={<Layout />}>
        <Route element={<HeroPage />} path="/" />
        <Route element={<AboutPage />} path="/about" />
        <Route element={<SkillsPage />} path="/skills" />
        <Route element={<ExperiencePage />} path="/experience" />
        <Route element={<ProjectsPage />} path="/projects" />
        <Route element={<CertificatesListPage />} path="/certificates" />
        <Route element={<CertificatePage />} path="/certificates/:slug" />
        <Route element={<ResumePage />} path="/resume" />
        <Route element={<ResearchPage />} path="/research" />
        <Route element={<BooksPage />} path="/books" />
        <Route element={<ContactPage />} path="/contact" />
        <Route element={<NotFoundPage />} path="*" />
      </Route>
    </Routes>
  );
}

export default App;
